import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { taxGroupEndpoints } from '@/lib/api/endpoints';
import { taxGroupKeys } from '@/lib/queryKeys';
import type { TaxGroup } from '@/types/tax';

export function useTaxGroups() {
  return useApiQuery<TaxGroup[]>({
    queryKey: taxGroupKeys.list(),
    queryFn: () => apiGet<TaxGroup[]>(operationsClient, taxGroupEndpoints.list()),
  });
}
